<template>

    <b-modal size="xl" button-size="sm" v-model="showModal" :title="prefix + title" hide-footer @hidden="fecharModal">

        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">


                    <b-form-row @keyup.enter="load">

                        <b-col cols="2" class="text-left">
                            <lg-form-input v-model="codigo" label="Identificador:" />
                        </b-col>

                        <b-col cols="3">
                            <lg-finder-page-pessoa id="finderPessoaFiscal" @onselect="setPessoa"
                                :prefix="prefix + title + ' > '" description="" v-model="fiscal" label="Fiscal:">
                            </lg-finder-page-pessoa>

                        </b-col>

                        <b-col cols="2" class="d-flex justify-content-end mt-2">

                            <div :id="'relatorioSemLocalXlsx-'">
                                <img @click="gerarRelatorioSemLocal('EXCEL')" :src="xlsIcon" class="img img--clickable"
                                    alt="XLSX" />
                                <b-tooltip :target="'relatorioSemLocalXlsx-'"
                                    title="GERAR XLSX DE RELATÓRIO DOS INVENTÁRIOS DE IBP SEM LOCAL" />
                            </div>
                            <div :id="'relatorioSemLocalOds'">
                                <img @click="gerarRelatorioSemLocal('ODS')" :src="ods" class="img img--clickable"
                                    alt="ODS" />
                                <b-tooltip :target="'relatorioSemLocalOds'"
                                    title="GERAR ODS DE RELATÓRIO DOS INVENTÁRIOS DE IBP SEM LOCAL"></b-tooltip>
                            </div>

                            <div :id="'relatorioSemLocalPdf'">
                                <img @click="gerarRelatorioSemLocal('PDF')" :src="pdf" class="img img--clickable"
                                    alt="PDF" />
                                <b-tooltip :target="'relatorioSemLocalPdf'"
                                    title="GERAR PDF DE RELATÓRIO DOS INVENTÁRIOS DE IBP SEM LOCAL"></b-tooltip>


                            </div>

                        </b-col>


                        <b-col cols="2" class="d-flex justify-content-end mt-2">

                            <div :id="'relatorioGeralXlsx-'">
                                <img @click="gerarRelatorio('EXCEL')" :src="xlsIcon" class="img img--clickable"
                                    alt="XLSX" />
                                <b-tooltip :target="'relatorioGeralXlsx-'"
                                    title="GERAR XLSX DE RELATÓRIO DOS INVENTÁRIOS DE IBP" />
                            </div>
                            <div :id="'relatorioGeralOds'">
                                <img @click="gerarRelatorio('ODS')" :src="ods" class="img img--clickable" alt="ODS" />
                                <b-tooltip :target="'relatorioGeralOds'"
                                    title="GERAR ODS DE RELATÓRIO DOS INVENTÁRIOS DE IBP"></b-tooltip>
                            </div>

                            <div :id="'relatorioGeralPdf'">
                                <img @click="gerarRelatorio('PDF')" :src="pdf" class="img img--clickable" alt="PDF" />
                                <b-tooltip :target="'relatorioGeralPdf'"
                                    title="GERAR PDF DE RELATÓRIO DOS INVENTÁRIOS DE IBP"></b-tooltip>


                            </div>
                            <b-form-group class="ml-2 mr-3" style="margin-top: -5px;">
                                <label style="color: black; text-decoration: none; font: 12px Inter sans-serif"
                                    for="paisagem">Paisagem</label>
                                <b-form-checkbox id="paisagem" v-model="rotacionar">
                                </b-form-checkbox>
                            </b-form-group>




                        </b-col>


                        <b-col cols="2" class="mt-2">
                            <span v-if="(master || possuiFiscal())" id="relatorioPdf-comunicado">
                                <img @click="gerarPdfComunicadoFiscalSetorial" :src="pdf" class="img img--clickable"
                                    alt="PDF" />
                                <b-tooltip target="relatorioPdf-comunicado"
                                    title="Comunicado - Fiscal Setorial"></b-tooltip>
                            </span>

                            <span v-if="(master || possuiFiscal())"
                                id="relatorioPdf-termo-recebimento-provisorio-personalizado">
                                <img @click="gerarPdfRecebimentoProvisorioPersonalizado" :src="pdf"
                                    class="img img--clickable" alt="PDF" />
                                <b-tooltip target="relatorioPdf-termo-recebimento-provisorio-personalizado"
                                    title="Escolher etiquetas - Termo de Recebimento Provisório de Inventário"></b-tooltip>
                            </span>


                            <span v-if="(master || possuiFiscal())" id="relatorioPdf-termo-recebimento-provisorio">
                                <img @click="gerarPdfRecebimentoProvisorio" :src="pdf" class="img img--clickable"
                                    alt="PDF" />
                                <b-tooltip target="relatorioPdf-termo-recebimento-provisorio"
                                    title="Termo de Recebimento Provisório de Inventário"></b-tooltip>
                            </span>
                            <span v-if="(master || possuiFiscal())" id="relatorioPdf-termo-rejeicao-provisorio">
                                <img @click="gerarPdfRecebimentoRejeicao" :src="pdf" class="img img--clickable"
                                    alt="PDF" />
                                <b-tooltip target="relatorioPdf-termo-rejeicao-provisorio"
                                    title="Termo de Rejeição de Inventário"></b-tooltip>
                            </span>

                        </b-col>

                        <b-col cols="3" class="text-right mt-2">
                            <b-button id="limparArmazenamentoModalRelatorio" class="mr-2 my-2" size="sm"
                                style="height: 20px" pill variant="primary" @click="clearForm">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="eraser" /> &nbsp;
                                </div>
                                <b-tooltip target="limparArmazenamentoModalRelatorio" title="Limpar"></b-tooltip>
                            </b-button>

                            <b-button id="localizarArmazenamentoModalRelatorios" class="mr-2 my-2" size="sm"
                                style="height: 20px" pill variant="primary" @click="load()">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" /> &nbsp;
                                </div>
                                <b-tooltip target="localizarArmazenamentoModalRelatorios" title="Localizar"></b-tooltip>
                            </b-button>
                        </b-col>
                    </b-form-row>
                    <b-row>
                        <span>({{ quantidadesItens }}) item(s) selecionados</span>

                    </b-row>
                    <b-row>

                        <b-table responsive class="mt-2" small show-empty :items="records" :fields="locaisFields"
                            :busy="busy">
                            <template #empty>
                                <h6 style="text-align: center">Nenhum registro encontrador</h6>
                            </template>


                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>

                            <template #head(select)>
                                <b-form-checkbox :checked="todosSelecionados" @change="selecionarTodos"
                                    :id="'checkboxSelecionarTodos'" size="lg" />

                            </template>

                            <template v-slot:cell(select)="row">
                                <b-form-checkbox @change="selecionarIndividual(row.item)"
                                    :id="'checkboxSelecionar' + row.item.id" v-model="row.item.selecionado" size="lg"
                                    :value="true" :unchecked-value="false" />
                            </template>


                        </b-table>
                        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{
                                    page }} de
                                    {{
                                        totalPage }} -
                                    {{ total }} registros</b-col>
                                <b-col cols="6"
                                    style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                    <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                        :options="perPageOptions">
                                    </b-form-select>
                                </b-col>
                            </b-col>
                            <b-col cols="6">
                                <div class="d-flex justify-content-end align-items-end">
                                    <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                        :per-page="perPage" :total-rows="total"></b-pagination>
                                </div>
                            </b-col>
                        </b-row>

                    </b-row>
                </b-card>
            </b-card-body>
        </b-card>
        <b-modal size="xl" button-size="sm" v-model="mostrarSelecionarEtiquetas"
            :title="prefix + title + ' > Selecionar etiquetas'" hide-footer @hidden="fecharModalEtiquetas">
            <b-table responsive class="mt-2" small :busy="this.busy" :items="this.etiquetas"
                :fields="this.tableFieldsEtiquetas" show-empty>


                <template #head(select)>
                    <b-form-checkbox :checked="todosSelecionadosEtiquetas" @change="selecionarTodosEtiquetas"
                        :id="'checkboxSelecionarTodosEtiquetas'" size="lg" />

                </template>

                <template v-slot:cell(select)="row">
                    <b-form-checkbox @change="selecionarIndividualEtiqueta(row.item)"
                        :id="'checkboxSelecionarEtiquetas' + row.item.id" v-model="row.item.selecionado" size="lg"
                        :value="true" :unchecked-value="false" />
                </template>

            </b-table>

            <b-form-row>


                <b-col cols="3"></b-col>
                <b-col cols="6" class="text-center">
                    <b-button :disabled="!etiquetasSeleionadas || etiquetasSeleionadas.length == 0" id="gerar"
                        class=" my-2" size="sm" pill variant="success"
                        @click="() => { gerarConteudoPdfRecebimentoProvisorioGerandoLocalAntes(etiquetasSeleionadas) }">
                        <b-icon icon="check-circle" />
                        <b-tooltip target="gerar" title="Gerar PDF"></b-tooltip>

                    </b-button>

                </b-col>
                <b-col cols="3"></b-col>

            </b-form-row>


        </b-modal>
    </b-modal>
</template>

<script>
import PdfIcon from "@/core/assets/icons/pdf.png";
import jsPDF from 'jspdf';
import Spalm from "@/core/assets/img/spalm.png";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";

import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"
import { getContext } from "@/core/auth"
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";
import xlsIcon from "@/core/assets/icons/xls.png";
import odsIcon from "@/core/assets/icons/ods.png";


export default {

    components: {
        LgFormInput,
        LgFinderPagePessoa
    },

    props: {
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Relatórios"
        }


    },

    data() {
        return {
            locais: [],
            etiquetasSeleionadas: [],
            etiquetas: [],
            mostrarSelecionarEtiquetas: false,
            semLocal: false,
            fiscal: {},
            rotacionar: false,
            busy: false,
            codigo: "",
            locaisSelecionados: [],
            showModal: true,
            SpalmLogo: Spalm,
            pdf: PdfIcon,
            xlsIcon: xlsIcon,
            ods: odsIcon,

            master: getContext().usuario.master,
            usuario: getContext().usuario.codUsuarioRH,
            nomeUsuario: getContext().usuario.nome,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: {},

        };
    },
    mixins: [FormResourceMixin, ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/local-armazenamento`);

        this.load();


    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        todosSelecionados: {
            get() {
                return this.records && this.records.length > 0 && this.records.every(i => i.selecionado);
            },
            set(valor) {
                this.records.forEach(i => i.selecionado = valor);
            }
        },

        todosSelecionadosEtiquetas: {
            get() {
                return this.etiquetas && this.etiquetas.length > 0 && this.etiquetas.every(i => i.selecionado);
            },
            set(valor) {
                this.etiquetas.forEach(i => i.selecionado = valor);
            }
        },

        quantidadesItens() {
            return this.locaisSelecionados.length;
        },

        locaisFields() {
            return [
                {
                    key: "select",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },


                {
                    key: "descricao",
                    label: "Descrição",
                },
                {
                    key: "tipoLocalArmazenamento.descricao",
                    label: "Tipo Local",
                },
                { key: "codigo", label: "Identificador", },
            ];
        },

        tableFieldsEtiquetas() {
            return [
                {
                    key: "select",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },

                {
                    key: "local",
                    label: "Local Armazenamento"
                },

                {
                    key: "tombamento",
                    label: "Etiqueta"
                },
                {
                    key: "descricao",
                    label: "Descrição"
                },

            ]
        },

        tableFields() {
            return [
                {
                    key: "divergencia",
                    label: " "
                },
                {
                    key: "action",
                    label: " ",
                },


                {
                    key: "tombamento",
                    label: "Tombamento",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },
                },
                {
                    key: "novaetiqueta",
                    label: "Etiqueta Provisória",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },

                {
                    key: "responsavel",
                    label: "Responsável",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "coResponsavel",
                    label: "CoResponsável",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },

                {
                    key: "departamentos",
                    label: "UORG",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },

                {
                    key: "classificador",
                    label: "Classificador",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "descricao",
                    label: "Descrição",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "codigodependencia",
                    label: "Código Dependência",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "nomedependencia",
                    label: "Nome Dependência",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "marca",
                    label: "Marca",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "modelo",
                    label: "Modelo",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "numerodeserie",
                    label: "Número Série",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },

                {
                    key: "estadoconservacao",
                    label: "Estado de Conservação",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },

                {
                    key: "tipoetiqueta",
                    label: "Tipo Etiqueta",
                    tdClass: (value, index, item) => {

                        return item.divergente ? "text-danger p-1" : "p-1"
                    },

                },
            ];
        },
    },
    methods: {
        setPessoa(pessoa) {
            this.fiscal = pessoa;
            this.load();
        },
        clearForm() {
            this.locaisSelecionados = [];
            this.codigo = "";
            this.load();
        },
        selecionarIndividual(item) {
            const index = this.locaisSelecionados.findIndex(sel => sel.id === item.id);

            if (item.selecionado && index === -1) {
                this.locaisSelecionados.push(item);
            } else if (!item.selecionado && index !== -1) {
                this.locaisSelecionados.splice(index, 1);
            }
        },

        selecionarIndividualEtiqueta(item) {
            const index = this.etiquetasSeleionadas.findIndex(sel => sel.id === item.id);

            if (item.selecionado && index === -1) {
                this.etiquetasSeleionadas.push(item);
            } else if (!item.selecionado && index !== -1) {
                this.etiquetasSeleionadas.splice(index, 1);
            }
        },

        selecionarTodos(valor) {
            this.records.forEach(record => {
                record.selecionado = valor;

                const jaSelecionado = this.locaisSelecionados.some(sel => sel.id === record.id);

                if (valor && !jaSelecionado) {
                    this.locaisSelecionados.push(record);
                } else if (!valor && jaSelecionado) {
                    this.locaisSelecionados = this.locaisSelecionados.filter(sel => sel.id !== record.id);
                }
            });
        },

        selecionarTodosEtiquetas(valor) {
            this.etiquetas.forEach(etiqueta => {
                etiqueta.selecionado = valor;

                const jaSelecionado = this.etiquetasSeleionadas.some(sel => sel.id === etiqueta.id);

                if (valor && !jaSelecionado) {
                    this.etiquetasSeleionadas.push(etiqueta);
                } else if (!valor && jaSelecionado) {
                    this.etiquetasSeleionadas = this.etiquetasSeleionadas.filter(sel => sel.id !== etiqueta.id);
                }
            });
        },



        possuiFiscal() {
            var possuiFiscal = false;
            this.locaisSelecionados.forEach(localizacao => {
                if (localizacao.codFiscais.includes(this.usuario))
                    possuiFiscal = true;
            });

            return possuiFiscal;
        },
        fecharModal() {
            this.$emit("close")
        },
        fecharModalEtiquetas() {
            this.etiquetas = [];
            this.etiquetasSeleionadas = [];
            this.mostrarSelecionarEtiquetas = false;
        },

        async gerarRelatorioSemLocal(tipoRelatorio) {
            this.semLocal = true;
            await this.gerarRelatorio(tipoRelatorio);
            this.semLocal = false;

        },

        async gerarRelatorio(tipoRelatorio) {
            const gerar = async (param) => {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-inventariosibp');
                const { data } = await resource.getWithParams(`${tipoRelatorio}`, param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            };

            this.busy = true;
            try {
                if (!this.locaisSelecionados || this.locaisSelecionados.length === 0) {


                    if (this.master) {
                        await gerar({ rotacionar: this.rotacionar, semLocal: this.semLocal });
                        return;
                    }
                    else {
                        this.$notify({
                            type: "danger",
                            message: 'É necessário escolher uma Localização Física!'
                        });
                        return;

                    }


                } else {
                    for (const localizacaoFisica of this.locaisSelecionados) {
                        await gerar({ local: localizacaoFisica.id, rotacionar: this.rotacionar });
                    }
                }
            } finally {
                this.busy = false;
            }
        },


        carregarImagemBase64(imgPath) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                fetch(imgPath)
                    .then(res => res.blob())
                    .then(blob => {
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(blob);
                    });
            });
        },


        async buscarEtiquetas(situacao, locais) {

            var param = { locais: locais.map(item => item.id).join(",") };

            const resource = new ResourceService(`/api/itembempermanente-inventario-filtro/buscar-etiquetas`)
            const { data } = await resource.getWithParams(`${situacao}`, param);

            return data;
        },

        desenharTabelaSimples(doc, cabecalhos, dados, x, y, larguraTotal, alturaLinhaBase = 8, padding = 2) {
            const colLargura = larguraTotal / cabecalhos.length;
            const alturaPagina = doc.internal.pageSize.getHeight();
            const margemInferior = 20;
            const alturaPorLinhaTexto = 6;

            const fonteAtual = doc.getFontSize();
            const fonteTabela = fonteAtual - 3;

            function novaPaginaSeNecessario(linhaAltura) {
                if (y + linhaAltura > alturaPagina - margemInferior) {
                    doc.addPage();
                    y = 20;
                }
            }

            const alturaCabecalho = alturaLinhaBase;
            const alturaMinimaLinha = alturaPorLinhaTexto + padding * 2;
            novaPaginaSeNecessario(alturaCabecalho + alturaMinimaLinha);

            // Cabeçalho
            doc.setFontSize(fonteTabela);
            doc.setFont('helvetica', 'bold');

            cabecalhos.forEach((texto, i) => {
                const px = x + i * colLargura;
                doc.rect(px, y, colLargura, alturaLinhaBase);
                doc.text(texto, px + colLargura / 2, y + alturaLinhaBase / 2 + 2, { align: 'center' });
            });

            y += alturaLinhaBase;

            doc.setFont('helvetica', 'normal');

            if (dados.length === 0) {
                const texto = "Nenhum registro encontrado";
                const alturaLinha = alturaPorLinhaTexto + padding * 2;

                novaPaginaSeNecessario(alturaLinha);

                doc.rect(x, y, larguraTotal, alturaLinha);

                doc.setFont('helvetica', 'italic');
                doc.setFontSize(fonteTabela);
                doc.text(texto, x + larguraTotal / 2, y + alturaLinha / 2 + 2, { align: 'center' });

                y += alturaLinha;

                doc.setFontSize(fonteAtual);
                doc.setFont('helvetica', 'normal');

                return y;
            }

            dados.forEach(linha => {
                const linhasDivididas = linha.map(function (texto) {
                    const colWidth = colLargura - padding * 2;

                    return doc.splitTextToSize(
                        String(texto === null || texto === undefined ? '' : texto),
                        colWidth
                    );
                });

                const maxLinhas = Math.max.apply(Math, linhasDivididas.map(function (l) {
                    return l.length;
                }));

                const alturaLinha = maxLinhas * alturaPorLinhaTexto + padding * 2;

                novaPaginaSeNecessario(alturaLinha);

                linhasDivididas.forEach(function (linhasTexto, i) {
                    const px = x + i * colLargura;

                    doc.rect(px, y, colLargura, alturaLinha);

                    linhasTexto.forEach(function (linhaTexto, j) {
                        doc.text(
                            linhaTexto,
                            px + padding,
                            y + padding + alturaPorLinhaTexto * (j + 1)
                        );
                    });
                });

                y += alturaLinha;
            });

            doc.setFontSize(fonteAtual);

            return y;
        },



        async gerarPdfComunicadoFiscalSetorial() {


            if (!this.locaisSelecionados || this.locaisSelecionados.length == 0) {
                this.$notify({
                    type: "danger",
                    message: 'É necessário escolher uma Localização Física!'
                });

                return;

            }

            this.busy = true;

            const spalmBase64 = await this.carregarImagemBase64(this.SpalmLogo);

            var locais = [];

            this.locaisSelecionados.forEach(async localizacaoFisica => {

                if (!localizacaoFisica.codFiscais.includes(this.usuario) && !this.master) {
                    this.$notify({
                        type: "danger",
                        message: 'O usuário logado não é fiscal na localização ' + localizacaoFisica.descricao
                    });

                } else
                    locais.push(localizacaoFisica);
            });

            const doc = new jsPDF();

            doc.addImage(spalmBase64, 'PNG', 150, 10, 40, 15);

            const margemEsquerda = 20;
            const larguraTexto = 170;
            const alturaPagina = 297;
            let y = 40;

            const dataAtual = new Date();
            const dataFormatada = dataAtual.toLocaleDateString('pt-BR');
            const horaFormatada = dataAtual.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

            function imprimirTextoQuebrado(doc, texto, x, y, largura, linhaAltura) {
                const linhas = doc.splitTextToSize(texto, largura);
                for (let i = 0; i < linhas.length; i++) {
                    if (y + linhaAltura > alturaPagina - 20) {
                        doc.addPage();
                        y = 20;
                    }
                    doc.text(linhas[i], x, y);
                    y += linhaAltura;
                }
                return y;
            }
            doc.setFontSize(12);

            doc.setFont('helvetica', 'Bold');
            y = imprimirTextoQuebrado(doc, "Prezado(a) Fiscal Setorial,", margemEsquerda, y, larguraTexto, 8);

            doc.setFont('helvetica', 'Normal');
            y += 15;

            y = imprimirTextoQuebrado(doc, "1 – Comunicamos que foi concluído o levantamento dos itens patrimoniais previstos na primeira fase do Contrato Administrativo nº 031/2024 (SEI nº 1604245), firmado entre a CONECTAA DESENVOLVIMENTO DE SISTEMAS LTDA e a Universidade Federal dos Vales do Jequitinhonha e Mucuri (UFVJM), nas dependências pelas quais Vossa Senhoria é responsável, na condição de Fiscal Técnico.", margemEsquerda, y, larguraTexto, 10);
            y = imprimirTextoQuebrado(doc, "2 – Nesse sentido, conforme estabelecido no processo de contratação, apresentamos, neste processo, o relatório referente às seguintes dependência(s):", margemEsquerda, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, `2.1 – ${locais.map(item => item.descricao + (item.codigo && item.codigo != "" ? (' - ' + item.codigo) : "")).join(", ")}`, margemEsquerda, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, "3 – Solicitamos que Vossa Senhoria verifique se o relatório corresponde aos itens existentes em cada dependência. Caso sejam identificadas divergências, o item deverá ser marcado como \"Divergente\" no sistema SPALM, gerado o Termo de Rejeição de Inventário e anexado a este processo.", margemEsquerda, y, larguraTexto, 8);

            let textoParte1 = "4 – O acesso ao sistema SPALM (disponível em: ";
            let url = "https://spalm-ufvjm.conectaa.com.br";
            let textoParte2 = ") deve ser ";
            let textoParte3 = "realizado informando, no campo \"login\", o e-mail institucional, que deverá ser alterado no primeiro acesso.";

            doc.setTextColor(0, 0, 0);
            doc.text(textoParte1, margemEsquerda, y);

            let xLink = margemEsquerda + doc.getTextWidth(textoParte1);

            doc.setTextColor(0, 0, 255);
            doc.textWithLink(url, xLink, y, { url: url });

            let linkWidth = doc.getTextWidth(url);
            doc.line(xLink, y + 0.5, xLink + linkWidth, y + 0.5);

            doc.setTextColor(0, 0, 0);

            let xDepois = xLink + linkWidth + 2;
            doc.text(textoParte2, xDepois, y);

            y += 8;

            y = imprimirTextoQuebrado(doc, textoParte3, margemEsquerda, y, larguraTexto, 8);

            y = imprimirTextoQuebrado(doc, "5 – Após o saneamento de todas as divergências, de forma que o relatório reflita fielmente os dados dos itens presentes na(s) dependência(s), Vossa Senhoria deverá marcá-los como “Aceito” no sistema SPALM, emitir o Termo de Recebimento Provisório de Inventário, anexá-lo ao processo e encaminhá-lo à unidade SEI (Patrimônio), para que a Fiscalização Técnica e o Gestor do Contrato possam dar prosseguimento aos procedimentos relacionados ao recebimento definitivo e ao pagamento dos serviços.", margemEsquerda, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, "6 – Ainda nesta fase, caso a unidade opte pela indicação de corresponsável, será necessário o preenchimento, para cada item no sistema SPALM, dos dados do corresponsável, que deverá ser cientificado quanto à necessidade de confirmação da aceitação da corresponsabilidade, por meio de link que será enviado ao e-mail do corresponsável.", margemEsquerda, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, "7 – Em caso de dúvidas, sugestões ou necessidade de apoio na conferência, gentileza entrar em contato pelo VOIP 8083 ou pelo celular/WhatsApp (51) 99675-2175.", margemEsquerda, y, larguraTexto, 8);

            y += 20;

            y = imprimirTextoQuebrado(doc, "Atenciosamente,", margemEsquerda, y, larguraTexto, 8);

            doc.text(`CONECTAA DESENVOLVIMENTO DE SISTEMAS LTDA`, 105, y, { align: 'center' });

            y += 20;

            if (y > alturaPagina - 20) {
                doc.addPage();
                y = 20;
            }




            doc.setFontSize(12);
            doc.text(`Gerado em ${dataFormatada} às ${horaFormatada} por ${this.nomeUsuario}`, 105, y, { align: 'center' });

            this.busy = false;
            doc.save('Comunicado - Fiscal Setorial.pdf');
        },

        async gerarPdfRecebimentoRejeicao() {

            if (!this.locaisSelecionados || this.locaisSelecionados.length == 0) {
                this.$notify({
                    type: "danger",
                    message: 'É necessário escolher uma Localização Física!'
                });

                return;

            }

            this.busy = true;

            var locais = [];
            this.locaisSelecionados.forEach(async localizacaoFisica => {

                if (!localizacaoFisica.codFiscais.includes(this.usuario) && !this.master) {
                    this.$notify({
                        type: "danger",
                        message: 'O usuário logado não é fiscal na localização ' + localizacaoFisica.descricao
                    });

                }
                else
                    locais.push(localizacaoFisica);
            });


            var etiquetas = await this.buscarEtiquetas(1, locais);
            if (!etiquetas || etiquetas.length == 0) {
                this.$notify({
                    type: "danger",
                    message: "O relatório só pode ser gerado quando houver divergências no inventário dessa(s) dependência(s)",
                });
                this.busy = false;
                return;
            }

            const spalmBase64 = await this.carregarImagemBase64(this.SpalmLogo);

            const doc = new jsPDF();

            doc.addImage(spalmBase64, 'PNG', 150, 10, 40, 15);

            const margemEsquerda = 20;
            const larguraTexto = 170;
            const alturaPagina = 297;
            let y = 40;

            const dataAtual = new Date();
            const dataFormatada = dataAtual.toLocaleDateString('pt-BR');
            const horaFormatada = dataAtual.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

            function imprimirTextoQuebrado(doc, texto, x, y, largura, linhaAltura) {
                const linhas = doc.splitTextToSize(texto, largura);
                for (let i = 0; i < linhas.length; i++) {
                    if (y + linhaAltura > alturaPagina - 20) {
                        doc.addPage();
                        y = 20;
                    }
                    doc.text(linhas[i], x, y);
                    y += linhaAltura;
                }
                return y;
            }

            doc.setFont('helvetica', 'Bold');
            doc.setFontSize(15);
            doc.text('TERMO DE REJEIÇÃO DO INVENTÁRIO', 105, y, { align: 'center' });

            doc.setFontSize(13);
            doc.setFont('helvetica', 'Normal');
            y += 15;

            const introducao = `Eu, ${this.nomeUsuario}, Fiscal Setorial, declaro, para os devidos fins, que:`;
            const texto1 = `1.  Tive acesso ao inventário patrimonial realizado na(s) dependência(s) abaixo.`;
            const texto2 = `2.  Após conferência física e documental dos itens relacionados, DECLARO a minha  REJEIÇÃO das sequintes etiquetas provisórias:`;
            const texto4 = `Solicito, portanto, a análise e providências cabíveis, com vistas à regularização dos registros e à correção das inconsistências apontadas.`;
            const rodape = `Este termo deverá ser anexado ao processo de inventário da Fiscalização Setorial.`;

            y = imprimirTextoQuebrado(doc, introducao, margemEsquerda, y, larguraTexto, 10);

            y = imprimirTextoQuebrado(doc, texto1, margemEsquerda, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, texto2, margemEsquerda, y, larguraTexto, 8);


            locais.forEach((local, i) => {
                const dadosLocal = [[i + 1, local.descricao, local.codigo || ""]];

                y += 4;
                y = this.desenharTabelaSimples(doc, ['Sequencial', 'Descrição', 'Código'], dadosLocal, margemEsquerda, y, larguraTexto);

                const etiquetasDoLocal = Array.isArray(etiquetas)
                    ? etiquetas.filter(e => e.idLocal === local.id)
                    : [];

                y += 1;

                if (etiquetasDoLocal.length > 0) {
                    const dadosEtiquetas = etiquetasDoLocal.map((e, i) => [i + 1, e.tombamento]);
                    y = this.desenharTabelaSimples(doc, ['Sequencial', 'Etiqueta'], dadosEtiquetas, margemEsquerda, y, larguraTexto);
                } else {
                    y = this.desenharTabelaSimples(doc, ['Sequencial', 'Etiqueta'], [], margemEsquerda, y, larguraTexto);
                }


                y += 8;
            });



            y = imprimirTextoQuebrado(doc, texto4, margemEsquerda, y, larguraTexto, 8);

            y += 10;
            y = imprimirTextoQuebrado(doc, rodape, 25, y, larguraTexto - 10, 8);

            y += 20;
            if (y > alturaPagina - 20) {
                doc.addPage();
                y = 20;
            }

            doc.setFontSize(12);
            doc.text(`Gerado em ${dataFormatada} às ${horaFormatada} por ${this.nomeUsuario}`, 105, y, { align: 'center' });

            this.busy = false;
            doc.save('Termo de Rejeição de Inventário.pdf');
        },


        async validarTermoRecebimentoProvisorio(validarEtiqueta) {

            if (!this.locaisSelecionados || this.locaisSelecionados.length == 0) {
                this.$notify({
                    type: "danger",
                    message: 'É necessário escolher uma Localização Física!'
                });

                return [];

            }

            this.busy = true;
            var locais = [];
            this.locaisSelecionados.forEach(async localizacaoFisica => {


                if (!localizacaoFisica.codFiscais.includes(this.usuario) && !this.master) {
                    this.$notify({
                        type: "danger",
                        message: 'O usuário logado não é fiscal na localização ' + localizacaoFisica.descricao
                    });

                }
                else
                    locais.push(localizacaoFisica);
            });

            var etiquetas = await this.buscarEtiquetas(0, locais);


            if (validarEtiqueta) {
                if (!etiquetas || etiquetas.length == 0) {
                    this.$notify({
                        type: "danger",
                        message: "O relatório do só pode ser gerado quando houver itens com etiquetas",
                    });
                    this.busy = false;
                    return [];
                }
            }

            return { locais, etiquetas };

        },

        async gerarConteudoPdfRecebimentoProvisorio(locais, etiquetas) {

            const spalmBase64 = await this.carregarImagemBase64(this.SpalmLogo);

            const doc = new jsPDF();

            doc.addImage(spalmBase64, 'PNG', 150, 10, 40, 15);

            const margemEsquerda = 20;
            const larguraTexto = 170;
            const alturaPagina = 297;
            let y = 40;

            const dataAtual = new Date();
            const dataFormatada = dataAtual.toLocaleDateString('pt-BR');
            const horaFormatada = dataAtual.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

            function imprimirTextoQuebrado(doc, texto, x, y, largura, linhaAltura) {
                const linhas = doc.splitTextToSize(texto, largura);
                for (let i = 0; i < linhas.length; i++) {
                    if (y + linhaAltura > alturaPagina - 20) {
                        doc.addPage();
                        y = 20;
                    }
                    doc.text(linhas[i], x, y);
                    y += linhaAltura;
                }
                return y;
            }

            doc.setFont('helvetica', 'Bold');
            doc.setFontSize(15);
            doc.text('TERMO DE RECEBIMENTO PROVISÓRIO DO INVENTÁRIO', 105, y, { align: 'center' });

            doc.setFontSize(13);
            doc.setFont('helvetica', 'Normal');
            y += 15;

            const introducao = `Eu, ${this.nomeUsuario}, na condição de Fiscal Setorial, declaro, para os devidos fins, que:`;
            const texto1 = `1.  Tive acesso ao inventário patrimonial realizado nas dependências abaixo descritas, contendo as seguintes etiquetas provisórias:`;
            const texto2 = `2.  Após conferência física e documental dos itens constantes no inventário, DECLARO a minha CONCORDÂNCIA com a listagem apresentada, reconhecendo como corretas as descrições, quantidades, números de tombamento e estado de conservação dos bens ali relacionados.`;
            const texto4 = `3.  Firmo o presente Termo para fins de registro e andamento das próximas etapas do inventário.`;
            const rodape = `Este termo deverá ser anexado ao processo de inventário da Fiscalização Setorial.`;


            y = imprimirTextoQuebrado(doc, introducao, margemEsquerda, y, larguraTexto, 10);
            y = imprimirTextoQuebrado(doc, texto1, margemEsquerda, y, larguraTexto, 8);

            var totalEtiquetas = 0;
            var totalNaoMetalicas = 0;
            var totalMetalicas = 0;
            var totaLivros = 0;

            locais.forEach((local, i) => {
                const dadosLocal = [[i + 1, local.descricao, local.codigo || "", local.totalEtiquetasMetalicas || 0, local.totalEtiquetasNaoMetalicas || 0, local.totalEtiquetasLivros || 0, (local.totalEtiquetasMetalicas || 0) + (local.totalEtiquetasNaoMetalicas || 0) + (local.totalEtiquetasLivros || 0)]];

                totalEtiquetas += (local.totalEtiquetasMetalicas || 0) + (local.totalEtiquetasNaoMetalicas || 0) + (local.totalEtiquetasLivros || 0);
                totalMetalicas += local.totalEtiquetasMetalicas || 0;
                totalNaoMetalicas += local.totalEtiquetasNaoMetalicas || 0;
                totaLivros += local.totalEtiquetasLivros || 0;

                y += 4;
                y = this.desenharTabelaSimples(doc, ['Sequencial', 'Descrição', 'Código', 'Metálicas', 'Não metálicas', 'Livros', 'Total'], dadosLocal, margemEsquerda, y, larguraTexto);

                const etiquetasDoLocal = Array.isArray(etiquetas)
                    ? etiquetas.filter(e => e.idLocal === local.id)
                    : [];

                y += 1;

                if (etiquetasDoLocal.length > 0) {
                    const dadosEtiquetas = etiquetasDoLocal.map((e, i) => [i + 1, e.tombamento]);
                    y = this.desenharTabelaSimples(doc, ['Sequencial', 'Etiqueta'], dadosEtiquetas, margemEsquerda, y, larguraTexto);
                } else {
                    y = this.desenharTabelaSimples(doc, ['Sequencial', 'Etiqueta'], [], margemEsquerda, y, larguraTexto);
                }


                y += 8;
            });

            var deslocadorMargem = 90;
            y = imprimirTextoQuebrado(doc, `Total de Etiquetas Não Metálicas: ${totalNaoMetalicas}`, margemEsquerda + deslocadorMargem, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, `Total de Etiquetas Metálicas: ${totalMetalicas}`, margemEsquerda + deslocadorMargem, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, `Total de Etiquetas de Livros: ${totaLivros}`, margemEsquerda + deslocadorMargem, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, `Total de Etiquetas: ${totalEtiquetas}`, margemEsquerda + deslocadorMargem, y, larguraTexto, 8);

            y = imprimirTextoQuebrado(doc, texto2, margemEsquerda, y, larguraTexto, 8);
            y = imprimirTextoQuebrado(doc, texto4, margemEsquerda, y, larguraTexto, 8);
            y += 10;
            y = imprimirTextoQuebrado(doc, rodape, 25, y, larguraTexto - 10, 8);

            y += 20;
            if (y > alturaPagina - 20) {
                doc.addPage();
                y = 20;
            }

            doc.setFontSize(12);
            doc.text(`Gerado em ${dataFormatada} às ${horaFormatada} por ${this.nomeUsuario}`, 105, y, { align: 'center' });

            doc.save('Termo de Recebimento Provisório de Inventário.pdf');
            this.busy = false;

        },

        async gerarConteudoPdfRecebimentoProvisorioGerandoLocalAntes(etiquetas) {

            var locaisSelecionados = JSON.parse(JSON.stringify(this.locaisSelecionados));
            locaisSelecionados.forEach(localizacaoFisica => {

                localizacaoFisica.totalEtiquetasMetalicas = 0;
                localizacaoFisica.totalEtiquetasNaoMetalicas = 0;
                localizacaoFisica.totalEtiquetasLivros = 0;

                etiquetas.forEach(etiqueta => {
                    if (etiqueta.idLocal === localizacaoFisica.id) {
                        if (etiqueta.tipoEtiqueta === 0) {
                            localizacaoFisica.totalEtiquetasMetalicas = (localizacaoFisica.totalEtiquetasMetalicas || 0) + 1;
                        } else if (etiqueta.tipoEtiqueta === 1) {
                            localizacaoFisica.totalEtiquetasNaoMetalicas = (localizacaoFisica.totalEtiquetasNaoMetalicas || 0) + 1;
                        } else if (etiqueta.tipoEtiqueta === 2) {
                            localizacaoFisica.totalEtiquetasLivros = (localizacaoFisica.totalEtiquetasLivros || 0) + 1;
                        }
                    }
                });
            });

            this.gerarConteudoPdfRecebimentoProvisorio(locaisSelecionados, etiquetas);

        },

        async gerarPdfRecebimentoProvisorio() {

            var termoRecebimento = await this.validarTermoRecebimentoProvisorio(false);

            if (!termoRecebimento || termoRecebimento.length == 0) {
                return;
            }

            var locais = termoRecebimento.locais;
            var etiquetas = termoRecebimento.etiquetas;

            this.gerarConteudoPdfRecebimentoProvisorio(locais, etiquetas);
        },
        async gerarPdfRecebimentoProvisorioPersonalizado() {
            var termoRecebimento = await this.validarTermoRecebimentoProvisorio(true);

            if (!termoRecebimento || termoRecebimento.length == 0) {
                return;
            }

            this.locais = termoRecebimento.locais;
            this.etiquetas = termoRecebimento.etiquetas;

            this.mostrarSelecionarEtiquetas = true;

        },
        async load() {
            this.filtro = {};
            this.busy = true;

            if (this.fiscal && this.fiscal.id) {
                this.filtro.fiscal = this.fiscal.id;
            }

            if (this.codigo && this.codigo != "") {
                this.filtro.codigo = this.codigo;
            }

            this.filtro.carregarTotalEtiquetas = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

            this.busy = true;
            this.locaisSelecionados.forEach(recordSelecionado => {
                if (this.records)
                    this.records.forEach(record => {
                        if (recordSelecionado.id == record.id)
                            record.selecionado = true;
                    });
            }
            );
            this.busy = false;

        },

    },

};
</script>

<style scoped>
.text-danger {
    color: red;
}
</style>